"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CoreArtistryServices() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const experiences = [{
    number: "01",
    title: "Maquillaje",
    description: "Precision artistry designed for high-fashion photography, model portfolios, and professional editorial shoots.",
    image: "https://nikibmakeup.com/wp-content/uploads/2026/06/Screenshot-2026-06-09-151759.png?v=m6juv2dwkh",
    srcset: "https://nikibmakeup.com/wp-content/uploads/2026/06/Screenshot-2026-06-09-151759.png?v=cs1qbjchc8k",
    sizes: "https://nikibmakeup.com/wp-content/uploads/2026/06/Screenshot-2026-06-09-151759.png?v=t6m615fn6k9",
    alt: "Professional editorial makeup look",
    link: "VER DETALLES SERVICIO"
  }, {
    number: "02",
    title: "Cabello & Maquillaje",
    description: "A complete, cohesive aesthetic transformation combining sophisticated hair styling with flawless makeup application.",
    image: "https://nikibmakeup.com/wp-content/uploads/2026/06/Screenshot-2026-06-09-151714.png?v=akltp1sykkn",
    srcset: "https://nikibmakeup.com/wp-content/uploads/2026/06/Screenshot-2026-06-09-151714.png?v=lwrt6t00w59",
    sizes: "https://nikibmakeup.com/wp-content/uploads/2026/06/Screenshot-2026-06-09-151714.png?v=uemgboamy2",
    alt: "Professional hair and makeup styling session",
    link: "VER DETALLES SERVICIO"
  }];
  return <section data-section-id="4486" id="core-artistry-services" className="relative dark bg-background text-foreground py-32 md:py-44 lg:py-[180px] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {}
        <div ref={headerRef} className={`text-center mb-20 md:mb-28 transition-all duration-[900ms] ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs md:text-sm uppercase tracking-[0.3em] mb-8" style={{
          color: "var(--chart-1)"
        }}>Servicios Distintivos de Niki</p>
          <h2 className="font-serif font-default text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[72px] leading-[1.05] tracking-tight max-w-[18ch] mx-auto">
            Belleza refinada para el lente moderno.
          </h2>
        </div>

        {}
        <div ref={gridRef} className={`relative grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-0 transition-all duration-[900ms] ease-out delay-150 ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="hidden md:flex absolute left-1/2 top-0 bottom-0 -translate-x-1/2 items-center justify-center pointer-events-none" aria-hidden="true">
            <div className="relative h-full w-px" style={{
            backgroundColor: "var(--chart-4)",
            opacity: 0.4
          }}>
              <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-2 h-2 rounded-lg" style={{
              backgroundColor: "var(--chart-1)"
            }} />
            </div>
          </div>

          {}

          {experiences.map((exp, i) => <div key={exp.number} data-index={i} className={`group relative ${i === 0 ? "md:pr-16 lg:pr-20" : "md:pl-16 lg:pl-20"}`}>
              {}
              <div className="relative overflow-hidden mb-8 aspect-[3/4]">
                <img src={exp.image} data-wvc-srcset={exp.srcset} data-wvc-sizes={exp.sizes} alt={exp.alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[600ms] ease-out group-hover:scale-[1.04]" />
              </div>

              {}
              <div className="font-mono text-sm tracking-[0.2em] mb-4" style={{
            color: "var(--chart-1)"
          }}>
                {exp.number}
              </div>

              {}
              <h3 className="font-serif font-default text-2xl md:text-3xl lg:text-[32px] leading-tight mb-4 transition-transform duration-500 ease-out group-hover:translate-x-1.5">
                {exp.title}
              </h3>

              {}
              <p className="font-default text-base leading-relaxed mb-6 max-w-md" style={{
            color: "var(--chart-3)"
          }}>
                Cada rostro es un lienzo. Elige un servicio distintivo, o colabora conmigo para crear un look completamente tuyo — cada sesión diseñada con dedicación inquebrantable al detalle.
              </p>

              {}
              <Link to={exp.link} className="inline-flex items-center gap-2 font-mono text-sm tracking-wider uppercase pb-1 border-b transition-all duration-500" style={{
            color: "var(--chart-1)",
            borderColor: "var(--chart-1)"
          }}>
                <span className="relative">
                  View service details
                </span>
                <ArrowUpRight className="size-4 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>

              {}
              {i === 0 && <div className="md:hidden mt-16 flex items-center justify-center" aria-hidden="true">
                  <div className="relative w-full h-px" style={{
              backgroundColor: "var(--chart-4)",
              opacity: 0.4
            }}>
                    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-2 h-2 rounded-lg" style={{
                backgroundColor: "var(--chart-1)"
              }} />
                  </div>
                </div>}
            </div>)}
        </div>

        {}
        <div ref={ctaRef} className={`mt-20 md:mt-28 text-center transition-all duration-[900ms] ease-out delay-300 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Link to="/ServicesPage" className="inline-flex items-center gap-2 font-mono text-xs md:text-sm uppercase tracking-[0.25em] pb-1 border-b transition-opacity duration-300 hover:opacity-80" style={{
          color: "var(--chart-1)",
          borderColor: "var(--chart-1)"
        }}>
            Ver Todos los Servicios
            <ArrowUpRight className="size-3.5" />
          </Link>
        </div>
      </div>
    </section>;
}